export enum HosDisplayPreferencesActionTypes {
    SET_SPLIT_SLEEPER_ENABLED = "SET_SPLIT_SLEEPER_ENABLED",
    CLEAR_SPLIT_SLEEPER_PREFERENCE = "CLEAR_SPLIT_SLEEPER_PREFERENCE"
}

export interface IHosDisplayPreference {
    splitSleeperEnabled: boolean;
}

export type IHosDisplayPreferences = IIdDictionary<IHosDisplayPreference>;
